import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import FairnessInput from './fairnessInput';
import { TranslationKeys } from '../../core/constants/translationKeys';
import FairnessButton from './fairnessButton';
import Calculator from '../calculator';
import AboutHashButton from './aboutHashButton';
import { checkHashStore } from '../../store/checkHashStore';
import { copyToClipboard } from '../../core/helpers/copyToClipboard';
import useTranslation from '../../hooks/useTranslation';
import AboutHashInfo from './aboutHashInfo';
import useSelfRemoveArray from '../../hooks/useSelfRemoveArray';

const FairnessInputsGroup = observer(({ isFromBetHistory }) => {
  const [isOpenCalculator, setIsOpenCalculator] = useState(false);
  const { lastRoundInfo, spinInfo, nextRoundHash } = checkHashStore;
  const [isShowAboutHash, setIsShowAboutHash] = useState(false);
  const [copiedInputType, addCopyInputType] = useSelfRemoveArray();

  const t = useTranslation();
  const { salt, key, hash } = useMemo(() => {
    if (spinInfo.key && spinInfo.salt && spinInfo.hash) {
      return spinInfo;
    }
    return lastRoundInfo;
  }, [spinInfo, lastRoundInfo]);

  const handleCopy = (value, type, isHashCode) => {
    if (!isHashCode) {
      checkHashStore.setCalculateSaltAndKey({ [type]: value });
    }
    if (value) {
      copyToClipboard(value);
      addCopyInputType(type);
    }
  };

  useEffect(() => {
    return () => {
      checkHashStore.resetCalculateSaltAndKey();
    };
  }, []);

  const handleToggleAboutHash = useCallback(() => {
    setIsShowAboutHash(!isShowAboutHash);
  }, [isShowAboutHash]);

  return (
    <div className='tab-main-information'>
      <div className='fairness-information'>
        <div className='cpt-input-wrapper'>
          <div className='input-head-wrapper'>
            <FairnessInput
              t={t}
              text={TranslationKeys.Key}
              value={key}
              type='key'
              isShowCopyIcon
              handleClick={handleCopy}
              copiedInputType={copiedInputType}
            />
            <FairnessInput
              t={t}
              text={TranslationKeys.Salt}
              value={salt}
              type='salt'
              isShowCopyIcon
              handleClick={handleCopy}
              copiedInputType={copiedInputType}
            />
          </div>
          <FairnessInput
            t={t}
            text={TranslationKeys.HashCode}
            value={hash}
            type='hash'
            isShowCopyIcon
            isHashCode
            handleClick={handleCopy}
            copiedInputType={copiedInputType}
          />
          <FairnessButton
            text={t(TranslationKeys.Check)}
            isDisabled={!salt.length || !key.length}
            handleClick={() => setIsOpenCalculator(!isOpenCalculator)}
          />
          {isOpenCalculator && (
            <Calculator handleCopy={handleCopy} copiedInputType={copiedInputType} />
          )}
          {!isFromBetHistory && (
            <div className='next-round-block'>
              <div className='next-round-block-txt'>{t(TranslationKeys.NextRound)}</div>
            </div>
          )}
          {!isFromBetHistory && (
            <FairnessInput
              t={t}
              text={TranslationKeys.HashCode}
              value={nextRoundHash}
              type='next_hash'
              isShowCopyIcon
              isHashCode
              handleClick={handleCopy}
              copiedInputType={copiedInputType}
            />
          )}
        </div>

        {!isFromBetHistory && <AboutHashButton handleClick={handleToggleAboutHash} t={t} />}
        {!isFromBetHistory && isShowAboutHash && <AboutHashInfo />}
      </div>
      <div className='history-information' />
    </div>
  );
});
export default FairnessInputsGroup;
